import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { FormValidator } from '../common/services/formValidator.service';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { EventHandlerService } from '../common/services/event-handler.service';
import { CongratulationsService } from '../finalModule/congratulations/congratulations.service';
import { PaymentStatusService } from '../paymentReview/paymentStatus.service';

declare const CreatePayment: any;

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
  providers: [PaymentService, CongratulationsService, PaymentStatusService]
})
export class PaymentStatusComponent implements OnInit {
  productCode: any;
  applicationId: any;
  headerDetails: any;
  instapackDetails: any;
  status: any;
  quoteId: any;
  statusCallCount: number = 0;
  public showLoader = false;
  public finalBannerAemArray = [];
  timelapStart: any;
  timelapEnd: any;
  timeDifference: any;
  paymentMainStatus: any;
  summaryData: any;
  PaymentDetails: any;
  PaymentData: any;
  disclaimer_msg: any;


  constructor(
    public _paymentStatusService: PaymentService,
    public _sessionHandlerService: SessionHandlerService,
    public FormValidators: FormValidator,
    public routeHandlerService: RouteHandlerService,
    public eventHandler: EventHandlerService,
    public _CongratulationsService: CongratulationsService,
    public paymentStatusService: PaymentStatusService,
    private _paymentService: PaymentService
  ) { }

  ngOnInit() {
    const paymentStatus = this.routeHandlerService.GetQueryParams('status');
    this.paymentMainStatus = paymentStatus;
    this.disclaimer_msg = CommonConstants.DISCLAIMER_TEXT;
    this.timelapStart = new Date().getTime();
    this.getSummaryDetails((response) => {
      if (paymentStatus == 'cancelled') {
        this.applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        this.quoteId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
        const payload = {
          payload: {
            applicationId: this.applicationId ? this.applicationId : null,
            quoteId: this.quoteId ? this.quoteId : null,
          },
          action: 'RetryBack'
        };
        this._paymentStatusService.postPaymentStatus(payload).subscribe((response) => {
          let eventStatus = '';
          const reqUrl = CommonConstants.APIURL.getPaymentStatusRoute.replace('{applicationId}', this.applicationId).replace('{quoteId}', this.quoteId);
          if (response.nextTask && response.nextTask.nextTaskKey)
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTask.nextTaskKey);
          if (response.nextTask.nextTaskKey === 'inProgress') {
            const serverEventObservable = this.eventHandler.getServerSentEvent(reqUrl).subscribe((eventResponse) => {
              console.log(JSON.parse(eventResponse.data).status);
              eventStatus = JSON.parse(eventResponse.data).status;
            }, (error) => {
              this.showLoader = false;
              this.redirectBasedOnEventStatus(this.applicationId, eventStatus);
            }
            );
          } else if (response.nextTask.nextTaskKey) {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTask.nextTaskKey);
            this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
          }
        }, (error) => {
          this.showLoader = false;
          console.log('Cancelled service call failed');
        }
        );
      }
      else {
        this.paymentStatus();
      }
    });


  }

  public paymentStatus() {
    if (this.paymentMainStatus == 'expired') {
      this._sessionHandlerService.SetSession('status', 'expired');
    }

    console.log(this.summaryData);
    this.showLoader = true;
    this.applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
    this.quoteId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
    const payload = {
      payload: {
        applicationId: this.applicationId ? this.applicationId : null,
        quoteId: this.quoteId ? this.quoteId : null,
      },
      action: 'payment'
    };

    const sessionValue = this.routeHandlerService.GetQueryParams('sessionId');
    const nextTaskKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.NextTaskKey);
    const reqUrl = CommonConstants.APIURL.getPaymentStatusRoute.replace('{applicationId}', this.applicationId).replace('{quoteId}', this.quoteId);
    let eventStatus = '';
    if (nextTaskKey !== 'inprogress' && !sessionValue) {
      this._paymentStatusService.postPaymentStatus(payload).subscribe((response) => {
        if (response.nextTask && response.nextTask.nextTaskKey)
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTask.nextTaskKey);
        if (response.nextTask.nextTaskKey === 'inProgress') {
          let countevnt = 0;
          const serverEventObservable = this.eventHandler.getServerSentEvent(reqUrl).subscribe((eventResponse) => {
            countevnt++;
            console.log(JSON.parse(eventResponse.data).status);
            eventStatus = JSON.parse(eventResponse.data).status;
            console.log(countevnt++)

          }, (error) => {
            this.showLoader = false;
            this.redirectBasedOnEventStatus(this.applicationId, eventStatus);
          }
          );
        } else {
          if (response.nextTask && response.nextTask.nextTaskKey)
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTask.nextTaskKey);
          this.routeHandlerService.RouteToNextTask(response.nextTask.nextTaskKey);
        }
      }, (error) => {
        this.showLoader = false;
      }
      );
    } else {
      // this.timelapStart = new Date().getTime();
      let countevnt = 0;
      const serverEventObservable = this.eventHandler.getServerSentEvent(reqUrl).subscribe((eventResponse) => {
        countevnt++
        console.log(JSON.parse(eventResponse.data).status);
        eventStatus = JSON.parse(eventResponse.data).status;
        console.log(countevnt);
      }, (error) => {
        console.log(countevnt);
        this.showLoader = false;
        this.redirectBasedOnEventStatus(this.applicationId, eventStatus);
      }
      );
    }
  }

  public getPaymentStatus() {
    this.statusCallCount++;
    this.applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
    this.quoteId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
    this._paymentStatusService.getPaymentStatus(this.quoteId, this.applicationId).subscribe((response) => {
      console.log(response)
      if (response.payload.paymentStatusResponse.paymentStatus == 'Success' || response.payload.paymentStatusResponse.paymentStatus == 'Failed') {
        this.paymentStatus();
      }
      else {
        if (this.statusCallCount == 4) {
          this.paymentStatus();
        }
        else {
          setTimeout(() => {
            this.getPaymentStatus();
          }, 2000);
        }
      }
    }, (error) => {
      console.log('getPaymentStatus Failed');
    }
    );
  }
  /*** Status Based redition from this function */
  public redirectBasedOnEventStatus(appId, evStatus) {
    const url = CommonConstants.APIURL.sendEventStatus.replace('{applicationId}', this.applicationId).replace('{quoteId}', this.quoteId);
    const postCallObservable = this.eventHandler.sendEventStatus(url, { quoteStatus: evStatus }).subscribe((statusResponse) => {
      if (!statusResponse.hasOwnProperty('errorCode')) {
        if (statusResponse.nextTask && statusResponse.nextTask.nextTaskKey)
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, statusResponse.nextTask.nextTaskKey);

        if (statusResponse.nextTask.nextTaskKey == "insPolicyPage") {
          this.timelapEnd = new Date().getTime();
          console.log(this.timelapStart)
          console.log(this.timelapEnd);
          this.timeDifference = this.timelapEnd - this.timelapStart;
          console.log(this.timeDifference);
          console.log(statusResponse);
          console.log(this.paymentMainStatus);
        }
        this.routeHandlerService.RouteToNextTask(statusResponse.nextTask.nextTaskKey);
      }
    }, (error) => {
      //this.routeHandlerService.RouteToNextTask([CommonConstants.Routes.ConnectionError]);
    });
    //this.subscriptions.add(postCallObservable);
  }
  public getSummaryDetails(cb?) {

    this.showLoader = true;
    this._CongratulationsService.showSummary().subscribe((response: ActivitiModel.MTResponse<any>) => {
      if (!response.errors) {
        if (response.payload) {
          this.summaryData = response.payload;
          console.log(this.summaryData)
          if (cb) {
            cb(response);
          }

        }
      } else {
        this.showLoader = false;
      }
    });
  }

  public getPaymentDetails() {

    const requestData = {
      applicationId: this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId),
      quoteId: this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
    };
    this.paymentStatusService.FetchPaymentStatus(requestData).subscribe((response) => {
      if (!response.errors) {
        this.PaymentData = response.payload;
        if (this.PaymentData) {
          if (this.PaymentData.paymentStatusResponse.paymentStatus.toLowerCase() === 'success') {
            this.PaymentDetails = this.PaymentData.paymentStatusResponse;


          }
        }
      }

    });

  }

  private setBannersAccordingEnviorment() {
    this._paymentService.getBanners().subscribe((res: any) => {
      this.finalBannerAemArray = res?.widgetComponentDetails[0]?.widgetComponentDetails;

      // Pick only  6 items from array
      this.finalBannerAemArray = this.finalBannerAemArray?.slice(0, 6);
      console.log('length:', this.finalBannerAemArray?.length);

    });
  }
}
